import { Form, Formik } from "formik";
import * as React from "react";
import { useState } from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import FFieldInput from "../../../../../components/Form/FFieldInput";
import { GameI } from "../../../../../types";

export const GameSearch: React.FC<{
    games: GameI[];
}> = (props) => {
    const { games } = props;

    const { t } = useTranslation();

    const [filteredGames, setFilteredGames] = useState<GameI[]>();

    const initialValues = {
        title: "",
    };

    const filterGames = (value: string) => {
        if (value.length > 2) {
            const regex = new RegExp(value.toLowerCase());
            const filtered = games.filter((game: GameI) => regex.test(game.title.toLowerCase()));
            setFilteredGames(filtered.splice(0, 10));
        } else {
            setFilteredGames(undefined);
        }
    };

    return (
        <>
            <Formik initialValues={initialValues} onSubmit={(values, { resetForm }) => {}}>
                {(formApi) => (
                    <Form>
                        <FFieldInput
                            formName={"title"}
                            label={t("Enter game title")}
                            labelAppend={null}
                            onChange={(value) => filterGames(value)}
                            floating={false}
                        />
                    </Form>
                )}
            </Formik>

            {filteredGames ? (
                <div className={"list-group mt-1"}>
                    <>
                        {filteredGames.length > 0 ? (
                            <>
                                {filteredGames.map((game: GameI) => (
                                    <NavLink
                                        key={`filtered-game-${game.url}`}
                                        className={"list-group-item list-group-item-action"}
                                        to={`/show-game/${game.url}`}
                                    >
                                        {game.title} ({game.platform})
                                    </NavLink>
                                ))}
                            </>
                        ) : (
                            <Alert variant={"warning"}>{`${t("No games found")} :-(`}</Alert>
                        )}
                    </>
                </div>
            ) : null}
        </>
    );
};
